export let LogoColor = /*#__PURE__*/function (LogoColor) {
  LogoColor["Light"] = "light";
  LogoColor["Dark"] = "dark";
  LogoColor["TransparentLight"] = "transparent-light";
  LogoColor["TransparentDark"] = "transparent-dark";
  return LogoColor;
}({});
export default LogoColor;